import descriptionSVG from "src/assets/description.svg";

const UploadingProgress = ({ progress, fileName }: { progress: number; fileName: string }) => {
  return (
    <div className="w-[460px] h-[81.63px] py-2 flex-col justify-start items-start gap-4 inline-flex">
      <div className="text-neutral-400 text-[13px] font-medium font-['Inter'] leading-none">Uploading (1 of 1)</div>
      <div className="self-stretch justify-center items-center gap-5 inline-flex">
        <div className="grow shrink basis-0 h-[33.63px] justify-start items-center gap-3 flex">
          <div className="w-6 h-6 relative">
          <img src={descriptionSVG}></img>
          </div>
          <div className="grow shrink basis-0 flex-col justify-center items-start gap-2 inline-flex">
            <div className="self-stretch justify-between items-center inline-flex">
              <div className="text-zinc-900 text-sm font-semibold font-['Inter'] leading-tight">{fileName}</div>
              <div className="text-zinc-900 text-[13px] font-semibold font-['Inter'] leading-none mr-[5%]">{progress}%</div>
            </div>
            <div className="self-stretch h-[5.63px] relative">
              <progress className="w-[93%] h-[5px] left-0 top-[0.63px] absolute bg-zinc-200 rounded-[5px]" max="100" value={progress} />
              <div className=" h-[5px] left-0 top-0 absolute bg-indigo-500 rounded-[5px]" style={{ width: `${progress}%` }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadingProgress;
